import { TopTeeth, bottomLeftTeeth, bottomRightTeeth } from '../LookUpType/teethArchType';
import TeethPosition from './TeethPosition';
import React from 'react';
import RadioRhf from '../../components/RadioRhf/RadioRhf';
import { RadioOptionRhf } from '../../components/RadioRhf/RadioOptionRhf';
import { useLang } from '../../../../util/lang';

/**
 * @param {Object} props - The props object
 * @param {string} props.question - The question
 * @param {string} props.name - The name prop from question
 * @param {Object} props.control - The control prop from react-hook-form
 * @param {string} [props.defaultValue=''] - The defaultValue prop
 * @param {Object} props.errors - The errors prop from react-hook-form
 * @param {Object} props.row - The row prop to determine the flex direction
 * @param {Array} [props.option=[]] - The question's option
 * @param {boolean} [props.disable] - The disable prop
 * @param {boolean} [props.teethSelectionDisabled=false] - The teethSelectionDisabled prop
 * @param {Object} props.selectedTooth - Value of selected tooth
 * @param {Function} props.setSelectedTooth - Setter function for teeth selection
 * @param {boolean} [props.showTeethSelection] - The showTeethSelection prop, can be undefined or boolean
 */
const TeethEquipmentRhf = ({
    question,
    name,
    control,
    defaultValue = '',
    errors,
    row,
    option = [],
    disable,
    teethSelectionDisabled = false,
    selectedTooth,
    setSelectedTooth,
    showTeethSelection = undefined,
    isTab,
    impressionType,
    subType,
    currentEditingType,
    radioOnChange,
}) => {
    const getDiffRetainerLang = useLang('DiffRetainer');
    return (
        <div>
            <section id={name}>
                <RadioRhf
                    row={row}
                    errors={errors}
                    defaultValue={defaultValue}
                    question={question}
                    name={name}
                    control={control}
                    formControlLabelRhf={
                        <>
                            {option.map((opt) => {
                                return (
                                    <RadioOptionRhf
                                        key={opt.value}
                                        value={opt.value}
                                        label={getDiffRetainerLang(`formOptions.${opt.label}`)}
                                        disable={disable}
                                        onChange={radioOnChange ? radioOnChange : null}
                                    />
                                );
                            })}
                        </>
                    }
                />
            </section>
            {showTeethSelection && (
                <>
                    <TeethPosition
                        teeth={TopTeeth}
                        side={'Top'}
                        disabled={teethSelectionDisabled}
                        selectedTooth={selectedTooth}
                        setSelectedTooth={setSelectedTooth}
                        isTab={isTab}
                        impressionType={impressionType}
                        subType={subType}
                        currentEditingType={currentEditingType}
                    />
                    <TeethPosition
                        teeth={{
                            bottomRigth: {
                                ...bottomRightTeeth,
                                minY: 45,
                                maxY: 120,
                            },
                            bottomLeft: {
                                ...bottomLeftTeeth,
                                minY: 45,
                                maxY: 120,
                            },
                        }}
                        disabled={teethSelectionDisabled}
                        selectedTooth={selectedTooth}
                        setSelectedTooth={setSelectedTooth}
                        isTab={isTab}
                        impressionType={impressionType}
                        subType={subType}
                        currentEditingType={currentEditingType}
                    />
                </>
            )}
        </div>
    );
};

export default TeethEquipmentRhf;
